/* Hayati Noir — theme script. No dependencies; loaded with `defer`. */
(() => {
  'use strict';

  const HY = window.HY || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (() => {
    let r = HY.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.endsWith('/') ? r : r + '/';
  })();
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const nativeFetch = window.fetch.bind(window);
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------------- Toast ---------------- */
  let toastTimer;
  const toast = (msg, isError) => {
    const el = $('#hy-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('toast--err', !!isError);
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-on'), 3200);
  };

  /* ---------------- Dialogs (drawers, search) ---------------- */
  const openDialog = (id, opener) => {
    const d = document.getElementById(id);
    if (!d || typeof d.showModal !== 'function') return false;
    if (!d.open) {
      d.showModal();
      document.documentElement.classList.add('lock');
    }
    d._opener = opener || document.activeElement;
    requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('is-open')));
    d.dispatchEvent(new CustomEvent('hy:open'));
    return true;
  };
  const closeDialog = (d) => {
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    const done = () => {
      if (!d.open) return;
      d.close();
      if (!$('dialog[open]')) document.documentElement.classList.remove('lock');
      if (d._opener && d._opener.focus) d._opener.focus({ preventScroll: true });
    };
    if (reduceMotion) done(); else setTimeout(done, 300);
  };
  $$('dialog.dlg').forEach((d) => {
    d.addEventListener('cancel', (e) => { e.preventDefault(); closeDialog(d); });
    d.addEventListener('click', (e) => { if (e.target === d) closeDialog(d); });
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const id = opener.dataset.open;
      if (id === 'cart-drawer' && HY.cartType === 'page') return;
      if (openDialog(id, opener)) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) { e.preventDefault(); closeDialog(closer.closest('dialog')); }
  });

  /* ---------------- Announcement rotation ---------------- */
  $$('[data-ann]').forEach((bar) => {
    const items = $$('.ann__m', bar);
    if (items.length < 2) { items[0] && items[0].classList.add('is-on'); return; }
    let i = 0;
    items[0].classList.add('is-on');
    if (reduceMotion) return;
    setInterval(() => {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, Number(bar.dataset.speed || 5) * 1000);
  });

  /* ---------------- Mega menu: keyboard / touch ---------------- */
  $$('.hd__item.has-mega > .hd__link').forEach((link) => {
    link.addEventListener('click', (e) => {
      if (matchMedia('(hover: none)').matches) {
        const item = link.parentElement;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          $$('.hd__item.is-open').forEach((x) => x.classList.remove('is-open'));
          item.classList.add('is-open');
        }
      }
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.hd__item')) $$('.hd__item.is-open').forEach((x) => x.classList.remove('is-open'));
  });

  /* ---------------- Cart ---------------- */
  const CART_SECTION = 'hy-cart-drawer';
  const countEls = () => $$('[data-cart-count]');

  const applyCartHTML = (html) => {
    if (!html) return;
    const doc = parse(html);
    const fresh = $('[data-cart-root]', doc);
    const cur = $('[data-cart-root]');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = fresh ? fresh.dataset.count : null;
    if (count != null) countEls().forEach((el) => { el.textContent = count; el.dataset.count = count; });
    const invalid = fresh && fresh.dataset.removeGifts;
    if (invalid) removeGifts(invalid.split(','));
  };

  const cartPost = async (path, body) => {
    document.documentElement.classList.add('cart-busy');
    try {
      const res = await nativeFetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(Object.assign({}, body, { sections: CART_SECTION, sections_url: location.pathname }))
      });
      const json = await res.json();
      if (!res.ok) throw json;
      if (json.sections) applyCartHTML(json.sections[CART_SECTION]);
      document.dispatchEvent(new CustomEvent('hy:cart', { detail: json }));
      return json;
    } finally {
      document.documentElement.classList.remove('cart-busy');
    }
  };

  const refreshCart = async () => {
    try {
      const res = await nativeFetch(`${root}?sections=${CART_SECTION}`, { headers: { Accept: 'application/json' } });
      const json = await res.json();
      applyCartHTML(json[CART_SECTION]);
    } catch (err) { /* never block the page */ }
  };

  /* A free gift whose spend tier is no longer met comes out of the bag (the drawer markup lists them). */
  let removingGifts = false;
  const triedGifts = new Set();
  const removeGifts = async (keys) => {
    keys = keys.filter((k) => k && !triedGifts.has(k));
    if (removingGifts || !keys.length) return;
    removingGifts = true;
    const updates = {};
    keys.forEach((k) => { updates[k] = 0; triedGifts.add(k); });
    try { await cartPost('cart/update.js', { updates }); } catch (e) { /* ignore */ }
    removingGifts = false;
    setTimeout(() => keys.forEach((k) => triedGifts.delete(k)), 5000);
  };

  const onCartPage = () => HY.pageType === 'cart';
  const afterChange = () => { if (onCartPage()) location.reload(); };

  const addItems = async (items, opener) => {
    const json = await cartPost('cart/add.js', { items });
    if (onCartPage()) { location.reload(); return json; }
    if (HY.cartType === 'page') { location.href = HY.cartUrl || root + 'cart'; return json; }
    openDialog('cart-drawer', opener);
    return json;
  };

  /* Product forms (product page, cards, upsells) */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action$="/cart/add"], form[data-quick-add]');
    if (!form || form.hasAttribute('data-native')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]') || e.submitter;
    const msg = form.querySelector('[data-form-msg]');
    if (msg) msg.hidden = true;

    const check = form.dispatchEvent(new CustomEvent('hy:validate', { cancelable: true }));
    if (!check) return;

    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    if (!id) return;
    const quantity = Math.max(1, Number(fd.get('quantity')) || 1);
    const properties = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') properties[m[1]] = v;
    }
    const item = { id, quantity };
    if (Object.keys(properties).length) item.properties = properties;
    const sp = fd.get('selling_plan');
    if (sp) item.selling_plan = Number(sp);
    const items = [item];
    $$('[data-addon]:checked', form).forEach((cb) => items.push({ id: Number(cb.value), quantity: 1 }));
    const scope = form.closest('[data-pdp]');
    if (scope && !form.contains(scope)) $$('[data-addon]:checked', scope).forEach((cb) => { if (!form.contains(cb)) items.push({ id: Number(cb.value), quantity: 1 }); });

    btn && btn.classList.add('is-busy');
    try {
      await addItems(items, btn);
      if (btn && form.hasAttribute('data-quick-add')) {
        btn.classList.add('is-done');
        setTimeout(() => btn.classList.remove('is-done'), 1600);
      }
    } catch (err) {
      const text = (err && (err.description || err.message)) || 'Something went wrong — please try again.';
      if (msg) { msg.textContent = text; msg.hidden = false; } else toast(text, true);
    } finally {
      btn && btn.classList.remove('is-busy');
    }
  });

  /* Line item quantity / remove / gifts / upsells */
  const changeLine = async (key, quantity) => {
    try { await cartPost('cart/change.js', { id: key, quantity }); afterChange(); }
    catch (err) { toast((err && err.description) || 'Could not update your bag.', true); refreshCart(); }
  };
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-qty-step]');
    if (q) {
      const wrap = q.closest('.qty');
      const input = wrap && $('input', wrap);
      if (!input) return;
      const next = Math.max(0, (Number(input.value) || 0) + Number(q.dataset.qtyStep));
      const li = q.closest('[data-key]');
      if (li) { e.preventDefault(); input.value = next; changeLine(li.dataset.key, next); }
      else { input.value = Math.max(1, next); input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.closest('[data-key]').dataset.key, 0); return; }

    const gift = e.target.closest('[data-gift-add]');
    if (gift) {
      e.preventDefault();
      gift.disabled = true;
      try {
        await cartPost('cart/add.js', { items: [{ id: Number(gift.dataset.giftAdd), quantity: 1, properties: { _hy_gift: gift.dataset.tier, 'Free gift': 'Unlocked at $' + gift.dataset.tier } }] });
        afterChange();
      } catch (err) { toast((err && err.description) || 'Could not add your gift.', true); }
      gift.disabled = false;
      return;
    }
    const up = e.target.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      up.classList.add('is-busy');
      try { await cartPost('cart/add.js', { items: [{ id: Number(up.dataset.upsellAdd), quantity: 1 }] }); afterChange(); }
      catch (err) { toast((err && err.description) || 'Could not add that item.', true); }
      up.classList.remove('is-busy');
      return;
    }
    const codeRm = e.target.closest('[data-code-remove]');
    if (codeRm) {
      e.preventDefault();
      const form = codeRm.closest('[data-codes]');
      const codes = JSON.parse(form.dataset.codes || '[]').filter((c) => c.toLowerCase() !== codeRm.dataset.codeRemove.toLowerCase());
      try { await cartPost('cart/update.js', { discount: codes.join(',') }); afterChange(); } catch (err) { refreshCart(); }
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-key] .qty input');
    if (input) changeLine(input.closest('[data-key]').dataset.key, Math.max(0, Number(input.value) || 0));
  });

  /* Promo codes */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('input[name=code]');
    const code = (input.value || '').trim();
    if (!code) return;
    const holder = form.closest('[data-codes]');
    const codes = JSON.parse((holder && holder.dataset.codes) || '[]');
    const msg = form.parentElement.querySelector('[data-code-msg]');
    try {
      const json = await cartPost('cart/update.js', { discount: codes.concat(code).join(',') });
      const bad = (json.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase() && !d.applicable);
      const target = $('[data-cart-root] [data-code-msg]') || msg;
      if (bad && target) { target.textContent = `"${code}" can't be used with the items in your bag.`; target.hidden = false; }
      afterChange();
    } catch (err) {
      if (msg) { msg.textContent = 'That code could not be applied.'; msg.hidden = false; }
    }
  });

  /* Keep the drawer in step with cart changes made by other scripts (apps, landing pages). */
  const CART_CALL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const isCartCall = (url) => { try { return CART_CALL.test(new URL(String(url), location.origin).pathname); } catch (e) { return false; } };
  const queueRefresh = debounce(refreshCart, 250);
  window.fetch = function (resource, init) {
    const p = nativeFetch(resource, init);
    const url = resource && resource.url ? resource.url : resource;
    if (isCartCall(url)) p.then((r) => { if (r && r.ok) queueRefresh(); }, () => {});
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__hyUrl = url; return xhrOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (isCartCall(this.__hyUrl)) this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) queueRefresh(); });
    return xhrSend.apply(this, arguments);
  };
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  /* ---------------- Search ---------------- */
  const searchDlg = $('#search-dialog');
  if (searchDlg) {
    const input = $('input[name=q]', searchDlg);
    const out = $('[data-ps-results]', searchDlg);
    const initial = out ? out.innerHTML : '';
    let ctrl;
    searchDlg.addEventListener('hy:open', () => setTimeout(() => input && input.focus(), 60));
    const run = debounce(async () => {
      const q = input.value.trim();
      if (!HY.predictive || q.length < 2) { out.innerHTML = initial; return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const url = `${HY.predictiveUrl || root + 'search/suggest'}?q=${encodeURIComponent(q)}&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=hy-predictive-search`;
        const res = await nativeFetch(url, { signal: ctrl.signal });
        const doc = parse(await res.text());
        const body = $('[data-ps]', doc);
        out.innerHTML = body ? body.innerHTML : '';
      } catch (err) { /* aborted or offline */ }
    }, 220);
    input && input.addEventListener('input', run);
  }

  /* ---------------- Reveal on scroll ---------------- */
  const revealEls = $$('[data-reveal]');
  if (revealEls.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) revealEls.forEach((el) => el.classList.add('in'));
    else {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach((el) => io.observe(el));
    }
  }

  /* ---------------- Tabs ---------------- */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[role=tab][data-tab]');
    if (!tab) return;
    const list = tab.closest('[role=tablist]');
    const scope = list.closest('[data-tabs]');
    $$('[role=tab]', list).forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
    $$('[role=tabpanel]', scope).forEach((p) => {
      p.hidden = p.id !== tab.dataset.tab;
      // closed tabs are shipped inside a <template>; unpack on first open
      const tpl = !p.hidden && p.querySelector(':scope > template[data-tab-tpl]');
      if (tpl) tpl.replaceWith(tpl.content);
    });
  });

  /* ---------------- Countdown ---------------- */
  $$('[data-countdown]').forEach((el) => {
    const end = new Date(el.dataset.countdown).getTime();
    if (!end) { el.hidden = true; return; }
    const parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      if (!left) { el.hidden = true; return false; }
      const d = Math.floor(left / 864e5), h = Math.floor(left / 36e5) % 24, m = Math.floor(left / 6e4) % 60, s = Math.floor(left / 1e3) % 60;
      if (parts.d) parts.d.textContent = d;
      if (parts.h) parts.h.textContent = String(h).padStart(2, '0');
      if (parts.m) parts.m.textContent = String(m).padStart(2, '0');
      if (parts.s) parts.s.textContent = String(s).padStart(2, '0');
      return true;
    };
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  });

  /* ---------------- YouTube (load only on click) ---------------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-yt]');
    if (!b) return;
    e.preventDefault();
    const wrap = document.createElement('div');
    wrap.className = 'yt-frame';
    wrap.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(b.dataset.yt)}?autoplay=1&rel=0&playsinline=1&modestbranding=1" title="${(b.dataset.title || 'Video').replace(/"/g, '&quot;')}" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
    if (b.dataset.ratio) wrap.style.aspectRatio = b.dataset.ratio;
    b.replaceWith(wrap);
  });

  /* Shopify-hosted product video: swap the poster for the real video on tap */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-video]');
    if (!b || !b.dataset.video) return;
    e.preventDefault();
    const v = document.createElement('video');
    Object.assign(v, { src: b.dataset.video, controls: true, autoplay: true, playsInline: true, loop: true });
    v.setAttribute('playsinline', '');
    v.style.cssText = 'width:100%;height:100%;object-fit:contain;background:#000';
    b.replaceWith(v);
  });

  /* ---------------- Localization auto-submit ---------------- */
  document.addEventListener('change', (e) => {
    const s = e.target.closest('[data-autosubmit]');
    if (s && s.form) s.form.submit();
  });

  /* ---------------- Product page ---------------- */
  $$('[data-pdp]').forEach((pdp) => {
    const dataEl = $('[data-variants]', pdp);
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const form = $('form[data-product-form]', pdp);
    const idInput = form && $('input[name=id]', form);
    const atcs = $$('[data-atc]', document);
    const gal = $('[data-gal]', pdp);
    const track = gal && $('[data-gal-track]', gal);

    const goTo = (i, smooth = true) => {
      if (!track) return;
      const slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    };
    if (gal && track) {
      const marks = $$('[data-gal-to]', gal);
      const setActive = (i) => marks.forEach((m) => m.setAttribute('aria-current', String(Number(m.dataset.galTo) === i)));
      marks.forEach((m) => m.addEventListener('click', () => goTo(Number(m.dataset.galTo))));
      $$('[data-gal-step]', gal).forEach((b) => b.addEventListener('click', () => {
        const w = track.clientWidth || 1;
        const cur = Math.round(track.scrollLeft / w);
        const n = track.children.length;
        goTo((cur + Number(b.dataset.galStep) + n) % n);
      }));
      track.addEventListener('scroll', debounce(() => setActive(Math.round(track.scrollLeft / (track.clientWidth || 1))), 60), { passive: true });
    }

    const selected = () => $$('[data-opt-group]', pdp).map((g) => { const c = $('input:checked', g); return c ? c.value : null; });
    const sync = (v) => {
      if (!v) {
        atcs.forEach((b) => { b.disabled = true; const l = $('[data-atc-label]', b); if (l) l.textContent = 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      $$('[data-price-now]', pdp).forEach((el) => { el.textContent = v.price; });
      $$('[data-price-was]', pdp).forEach((el) => { el.textContent = v.compare || ''; el.hidden = !v.compare; });
      $$('[data-save]', pdp).forEach((el) => { el.textContent = v.save || ''; el.hidden = !v.save; });
      $$('[data-sale-badge]', pdp).forEach((el) => { el.hidden = !v.badge; if (v.badge) el.textContent = v.badge; });
      $$('[data-opt-value]', pdp).forEach((el, i) => { el.textContent = v.options[i] || ''; });
      atcs.forEach((b) => {
        b.disabled = !v.available;
        const l = $('[data-atc-label]', b);
        if (l) l.textContent = v.available ? (b.dataset.labelAdd || 'Add to bag') + ' — ' + v.price : 'Sold out';
      });
      if (v.media != null) goTo(v.media);
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', url);
    };
    pdp.addEventListener('change', (e) => {
      if (!e.target.closest('[data-opt-group]')) return;
      const opts = selected();
      sync(variants.find((v) => v.options.every((o, i) => o === opts[i])));
    });

    /* Sticky add-to-bag */
    const sticky = $('[data-sticky]');
    const anchor = $('[data-atc-anchor]', pdp);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        // visible whenever the main button is off screen — below the fold on phones, or scrolled past
        sticky.classList.toggle('is-on', !en.isIntersecting);
        document.documentElement.classList.toggle('sticky-on', !en.isIntersecting);
      }).observe(anchor);
      $('[data-sticky-btn]', sticky).addEventListener('click', () => {
        if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.submit();
      });
    }
  });

  /* Create-your-own sets: customer picks N scents, saved as line item properties */
  $$('[data-pick]').forEach((pick) => {
    const need = Number(pick.dataset.need) || 3;
    const label = pick.dataset.label || 'Perfume Bottle';
    const form = pick.closest('form') || $('#' + pick.dataset.form);
    const slots = $$('[data-slot]', pick);
    const inputs = $$('[data-pick-input]', pick);
    const status = $('[data-pick-status]', pick);
    const picks = [];
    const render = () => {
      slots.forEach((s, i) => {
        const p = picks[i];
        s.classList.toggle('is-full', !!p);
        s.innerHTML = p ? `<img src="${p.img}" alt="" loading="lazy"><span class="pick__x" aria-hidden="true">×</span><span class="sr">Remove ${p.name}</span>` : `<span>${i + 1}</span>`;
        s.setAttribute('aria-label', p ? `Remove ${p.name}` : `Empty slot ${i + 1}`);
      });
      inputs.forEach((inp, i) => { inp.value = picks[i] ? picks[i].name : ''; });
      $$('[data-pick-opt]', pick).forEach((o) => {
        const n = picks.filter((p) => p.name === o.dataset.name).length;
        let b = $('b', o);
        if (n && !b) { b = document.createElement('b'); o.appendChild(b); }
        if (b) { if (n) b.textContent = n; else b.remove(); }
      });
      const left = need - picks.length;
      if (status) status.textContent = left > 0 ? `Choose ${left} more` : 'Your set is complete';
      $$('[data-atc]').forEach((btn) => {
        const l = $('[data-atc-label]', btn);
        if (!l) return;
        if (left > 0) { l.dataset.orig = l.dataset.orig || l.textContent; l.textContent = `Choose ${left} more`; }
        else if (l.dataset.orig) l.textContent = l.dataset.orig;
      });
    };
    pick.addEventListener('click', (e) => {
      const opt = e.target.closest('[data-pick-opt]');
      if (opt && !opt.disabled) {
        if (picks.length >= need) { toast('Your set is full — tap a bottle above to swap it.'); return; }
        picks.push({ name: opt.dataset.name, img: opt.dataset.img });
        render();
        return;
      }
      const slot = e.target.closest('[data-slot]');
      if (slot) { const i = slots.indexOf(slot); if (picks[i]) { picks.splice(i, 1); render(); } }
    });
    if (form) form.addEventListener('hy:validate', (e) => {
      if (picks.length < need) {
        e.preventDefault();
        toast(`Please choose ${need - picks.length} more ${need - picks.length === 1 ? 'scent' : 'scents'} for your set.`, true);
        pick.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    });
    inputs.forEach((inp, i) => { inp.name = `properties[${label} ${i + 1}]`; });
    render();
  });

  /* Recommendations (loaded after the page) */
  $$('[data-recs]').forEach(async (el) => {
    try {
      const res = await nativeFetch(el.dataset.recs);
      const doc = parse(await res.text());
      const fresh = $('[data-recs]', doc);
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML; else el.closest('.shopify-section').hidden = true;
    } catch (err) { /* leave placeholder */ }
  });

  /* ---------------- Collection filters, sort, load more ---------------- */
  $$('[data-coll]').forEach((coll) => {
    const sectionId = coll.dataset.section;
    const swap = async (url, push = true) => {
      coll.classList.add('cart-busy');
      try {
        const u = new URL(url, location.origin);
        u.searchParams.set('section_id', sectionId);
        const res = await nativeFetch(u.toString());
        const doc = parse(await res.text());
        ['[data-coll-results]', '[data-coll-filters]', '[data-coll-count]', '[data-coll-active]', '[data-coll-count-active]'].forEach((sel) => {
          const fresh = $$(sel, doc);
          $$(sel, coll).forEach((cur, i) => { if (fresh[i]) cur.innerHTML = fresh[i].innerHTML; });
        });
        u.searchParams.delete('section_id');
        if (push) history.pushState({ hyColl: true }, '', u.pathname + u.search);
      } catch (err) { location.href = url; }
      coll.classList.remove('cart-busy');
    };
    const fromForm = (form) => {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) if (v !== '') params.append(k, v);
      return `${location.pathname}?${params.toString()}`;
    };
    const onChange = debounce((form) => swap(fromForm(form)), 350);
    const filterForm = (el) => (el.form && el.form.matches('[data-filters]')) ? el.form : el.closest('form[data-filters]');
    coll.addEventListener('change', (e) => {
      const form = filterForm(e.target);
      if (form) onChange(form);
    });
    const panel = (open) => {
      coll.classList.toggle('flt-open', open);
      document.documentElement.classList.toggle('lock', open);
    };
    coll.addEventListener('submit', (e) => { const form = e.target.closest('form[data-filters]'); if (form) { e.preventDefault(); swap(fromForm(form)); } });
    coll.addEventListener('click', async (e) => {
      if (e.target.closest('[data-flt-open]')) { panel(true); return; }
      if (e.target.closest('[data-flt-close]')) { panel(false); return; }
      const a = e.target.closest('[data-coll-link]');
      if (a) { e.preventDefault(); swap(a.href); return; }
      const more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        more.classList.add('is-busy');
        try {
          const u = new URL(more.href, location.origin);
          u.searchParams.set('section_id', sectionId);
          const doc = parse(await (await nativeFetch(u.toString())).text());
          const grid = $('[data-coll-grid]', coll);
          $$('[data-coll-grid] > *', doc).forEach((card) => grid.appendChild(card));
          const nextMore = $('[data-more-wrap]', doc);
          const curMore = $('[data-more-wrap]', coll);
          if (curMore) curMore.innerHTML = nextMore ? nextMore.innerHTML : '';
        } catch (err) { location.href = more.href; }
      }
    });
    window.addEventListener('popstate', () => swap(location.href, false));
  });
})();
